export const tonKho = {
  title: 'Tồn kho',
  tabs: {
    list: 'Danh sách tồn kho',
    stats: 'Thống kê TQ / VN',
  },
  fields: {
    batchCode: 'Mã lô',
    customerCode: 'Mã KH',
    customerName: 'Khách hàng',
    productName: 'Hàng hóa',
    qty: 'SL tồn',
    unit: 'ĐVT',
    warehouseCode: 'Mã kho',
    warehouseName: 'Kho',
    weight: 'Trọng lượng',
    volume: 'Thể tích',
    note: 'Ghi chú',
  },
  filter: {
    searchPlaceholder: 'Tìm kiếm...',
    viewMode: 'Chế độ xem',
    warehouseId: 'ID kho (tùy chọn)',
  },
  viewMode: {
    byBatch: 'Chi tiết theo lô',
    byCustomer: 'Tổng hợp theo khách hàng',
  },
  actions: {
    exportExcel: 'Xuất Excel',
  },
  stats: {
    overview: 'Tổng quan',
    vn: 'Việt Nam',
    tq: 'Trung Quốc',
    other: 'Khác',
    metrics: {
      tongSoLo: 'Tổng số lô',
      tongSoKien: 'Tổng số kiện',
      tongTrongLuong: 'Tổng trọng lượng (kg)',
      tongTheTich: 'Tổng thể tích (cm³)',
      soLo: 'Số lô',
      soKien: 'Số kiện',
      trongLuong: 'Trọng lượng (kg)',
      theTich: 'Thể tích (cm³)',
    },
  },
  messages: {
    noData: 'Không có dữ liệu',
    noStats: 'Không có dữ liệu thống kê',
  },
}
